import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { AuthResult } from '@/contracts/system-modules/auth/dto/auth/AuthResult'
import { SignedParams } from '@/system-modules/auth/v1/api/v1/auth/Register/Dto/SignedParams'
import { offlineAuthResult } from '@/system-modules/auth/v1/api/v1/auth/Register/RegisterRoute'

export class LoginRoute extends AuthRoute<SignedParams, AuthResult> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/login'
  }

  offline(params: SignedParams): Promise<ApiResponse<AuthResult>> {
    if (params.signature === '') {
      return Promise.resolve(new ApiResponse({ success: false, error: 'invalid_signature' }))
    }

    return Promise.resolve(new ApiResponse({ success: true, data: offlineAuthResult() }))
  }
}
